<div class="relative z-10" style="height: calc(100% - 50px)">
  <y42-logo-loader
    *ngIf="state.gitOperationOngoing || state.loading.changes"
    class="center-absolute"
    [widthInPixel]="70"
  >
  </y42-logo-loader>
  <y42-git-commit-preview
    *ngIf="!state.loading.changes"
    [allowDiscardChanges]="!forceCommit"
    [(selectedItems)]="selectedItems"
    [changes]="state.changes"
    [allowCheckboxSelection]="!forceCommit"
    [disableFileTreeContextMenu]="forceCommit"
  >
    <ng-container aligner-end>
      <button *ngIf="!forceCommit" mat-icon-button class="close-btn ml-2" mat-dialog-close>
        <fa-icon class="text-gray-600 text-sm" [icon]="['fal', 'times']"></fa-icon>
      </button>
    </ng-container>
  </y42-git-commit-preview>
</div>
<div class="commit-action-bar">
  <div class="aligner w-[50px] h-full border-right">
    <y42-avatar
      [name]="state.activeUser.full_name"
      [src]="state.activeUser.profile_pic"
      [matTooltip]="state.activeUser.full_name"
      size="35"
    >
    </y42-avatar>
  </div>
  <mat-form-field class="grow grid-row-search h-full pl-3 border-right pr-3">
    <mat-label>Commit Title</mat-label>
    <input matInput [formControl]="form.controls.title" data-test="input-git-commit-title" />
  </mat-form-field>
  <mat-form-field class="grow grid-row-search h-full pl-3 pr-3">
    <mat-label>Commit Description</mat-label>
    <input matInput [formControl]="form.controls.description" data-test="input-git-commit-description" />
  </mat-form-field>
  <y42-git-stashed-changes-button [showRightChevron]="false"></y42-git-stashed-changes-button>

  <button
    mat-button
    color="primary"
    class="commit-btn fs-08"
    (click)="commit()"
    [disabled]="form.invalid || state.gitOperationOngoing || !selectedItems.length"
    data-test="button-git-commit"
    [intercomTarget]="'git-commit-btn'"
  >
    <fa-icon [icon]="['fal', 'code-commit']"></fa-icon>&nbsp;&nbsp;Commit
  </button>
</div>
